import { Trainer } from 'src/domain/dog'

export function trainerMapper(data: any): Trainer {
  return {
    ...data,
    createdAt: (data?.createdAt as any).toDate(),
  }
}
